var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_container"},[_c('h1',{staticClass:"_text-center p3"},[_vm._v("Geen Toegang")])])
}]

export { render, staticRenderFns }